import React from 'react';
import { Link } from 'gatsby';

const Navbar = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      navBarActiveClass: '',
    };
  }

  pathIncludes = (word) => {
    if (typeof window !== 'undefined') {
      return window.location.href.includes(word) ? 'navbar-item--active' : '';
    }
    return '';
  }

  // returns true when the current URL contains `word`
  isCurrentPath = (word) => {
    if (typeof window !== 'undefined') {
      return window.location.href.includes(word);
    }
    return false;
  }

  toggleHamburger = () => {
    const active = !this.state.active;
    this.setState({ active, navBarActiveClass: active ? 'is-active' : '' }, () => {
      // toggle the body helper class (used for CSS/other components)
      if (typeof document !== 'undefined') {
        document.body.classList.toggle('menu-open', active);
      }
      // notify any listeners (Sketch will listen for this to unmount)
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('menu-open', { detail: { open: active } }));
      }
    });
  }

  closeHamburger = () => {
    this.setState({ active: false, navBarActiveClass: '' }, () => {
      if (typeof document !== 'undefined') document.body.classList.remove('menu-open');
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('menu-open', { detail: { open: false } }));
      }
    });
  }

  render() {
    return (
      <nav
        className="navbar is-transparent is-fixed-top"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className={`container is-fluid ${this.state.navBarActiveClass}`}>
          <div className="navbar-brand">
            <Link to="/" className="navbar-item nav-logo" title="Logo" onClick={() => setTimeout(() => this.closeHamburger(), 500)}>
              <div className="nav-logo">
                <h3 className="title--techfont">O</h3>
              </div>
              {/* <img src={logo} alt="Kaldi" style={{ width: '88px' }} /> */}
            </Link>
            {/* Hamburger menu */}
            <div
              role="button"
              tabIndex={0}
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              onClick={() => this.toggleHamburger()}
              onKeyDown={() => this.toggleHamburger()}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-start has-text-centered">
              {!this.isCurrentPath('services') && (
                <Link className={`navbar-item ${this.pathIncludes('services')}`} to="/services" onClick={() => setTimeout(() => this.closeHamburger(), 500)}>
                  <p>Services</p>
                </Link>
              )}

              {!this.isCurrentPath('case-studies') && (
                <Link className={`navbar-item ${this.pathIncludes('case-studies')}`} to="/case-studies" onClick={() => setTimeout(() => this.closeHamburger(), 500)}>
                  <p>Case studies</p>
                </Link>
              )}

              {/* <Link className={'navbar-item ' + this.pathIncludes('about')}to="/blog">
                RESOURCES
              </Link> */}
              {/* <Link className={`navbar-item ${this.pathIncludes('journal')}`} to="/journal">
                <p>Journal</p>
              </Link> */}
              <Link className="navbar-item" to="/#footer" onClick={() => setTimeout(() => this.closeHamburger(), 500)}>
                <p>Contact</p>
              </Link>
              {/* <Link className="navbar-item" to="/contact/examples">
                Form Examples
              </Link> */}
            </div>
            {this.state.active
              ? (
                <div className="navbarFooter">
                  <p className="navbarFooter--item">TOM@ORTOM.AI</p>
                  <p className="navbarFooter--item">
                    <a
                      href="https://www.linkedin.com/in/tomliptrot1/"
                    >
                      LINKEDIN
                    </a>
                  </p>
                  <p className="navbarFooter--item">
                    <a
                      href="https://clutch.co/profile/ortom"
                    >
                      CLUTCH.CO
                    </a>
                  </p>
                </div>
              )
              : <div />}
          </div>
        </div>
      </nav>
    );
  }
};

export default Navbar;
